import { IGetReinspecaoEmAbertoUseCase } from "../../../presentation/useCases/read/get_reinspecao_em_aberto_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";
import { ReinspecaoEmAbertoLista } from "../../models/reinspecao_em_aberto";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";

/**
 * GetReinspecaoEmAbertoUseCase
 */

export class GetReinspecaoEmAbertoUseCase
  extends BasePaginatedUseCase<ReinspecaoEmAbertoLista>
  implements IGetReinspecaoEmAbertoUseCase {
  constructor(private readonly repository: IObrasRepository) {
    super();
  }

  async getReinspecaoEmAberto(
    idObra: number,
    area?: string,
    idsObraChecklistServicos?: number[],
    page?: number,
    rowsPerPage?: number,
  ): Promise<void> {
    const result = await this.repository.getReinspecaoEmAberto(idObra, area, idsObraChecklistServicos, page, rowsPerPage);

    this._items = result.items;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;
    this._totalItems = result.totalItems;
    this._totalPages = result.totalPages;

  }
}
